import media from 'styles/media.module.scss';
import styled from 'types/AppTheme';

const ModalButtonsWrapper = styled('div')<{ position?: 'center' | 'flex-start' }>`
  display: flex;
  width: 100%;
  justify-content: ${({ position }) => position || 'center'};
  gap: 12px;
  flex-wrap: wrap;
  margin-bottom: 28px;

  @media (max-width: ${media.maxMobile}) {
    margin-bottom: 0;

    & > button {
      flex-grow: 1;
      flex-basis: 205px;
    }

    & > a {
      display: block;
      flex-grow: 1;
      flex-basis: 205px;

      & > button {
        width: 100%;
      }
    }
  }
`;

export default ModalButtonsWrapper;
